import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#b995c9" },   // lilac
    secondary: { main: "#79d1c3" }, // soft teal
    background: {
      default: "linear-gradient(135deg, #b995c9 0%, #79d1c3 45%, #f8c38d 100%)",
      paper: "rgba(255,255,255,0.04)",
    },
    text: { primary: "#e7e4ec" },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: "'Roboto Condensed', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h6: { fontWeight: 500, letterSpacing: "0.5px" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          padding: 0,
          minHeight: "100vh",
          width: "100vw",
          background:
            "linear-gradient(135deg, #412f4bff 0%, #0d153ae4 50%, #103f44ff 100%)",
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
        },
        "#root": {
          height: "100vh",
          width: "100vw",
          background: "transparent",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(255,255,255,0.05)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 0 20px rgba(0,0,0,0.2)",
        },
      },
    },
  },
});

export default theme;
